<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">聚宝盆</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>云算力利息记录</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-date-picker
          type="datetimerange"
          v-model="times"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-input placeholder="请输入用户ID" v-model="form.userId"></el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <calculate @refresh="getList"></calculate>
        <!-- <el-button @click="calculate" type="warning" size="small">计算利息</el-button> -->
        <el-button @click="push" type="success" size="small"
          >发放利息</el-button
        >
      </div>
      <list @refresh="getList"></list>
    </el-card>
    <el-dialog> </el-dialog>
  </div>
</template>

<script>
import './store';
import { mapState, mapActions } from 'vuex';
import List from './components/list';
import moment from 'moment';
import Calculate from './components/calculate';

export default {
  name: 'mortgagerecord',
  data() {
    return {
      form: {},
      times: []
    };
  },
  components: {
    List,
    Calculate
  },
  computed: {
    ...mapState('miningbonus', ['pagination', 'coinTypeList']),
    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    }
  },
  methods: {
    ...mapActions('miningbonus', ['getRecords', 'sendAmount']),
    ...mapActions('mining', ['getCoinTypeList']),
    handleSearch() {
      this.getList({
        page: 1,
        startTime: this.startTime,
        endTime: this.endTime
      });
    },
    getList(data = {}) {
      this.getRecords({
        ...this.form,
        ...this.pagination,
        ...data
      });
    },
    push() {
      this.sendAmount().then(() => {
        this.$message.success('发放成功！');
      });
    }
  },
  mounted() {
    this.getList();
    this.getCoinTypeList();
  }
};
</script>
